"use client"

import { StyledTableCard } from "@/components/Card"
import { FormTitle } from "@/components/Inputs"
import { CustomSearch } from "@/components/Inputs/textFields"
import { getPublicDashboardStates } from "@/store"
import { isEmpty } from "lodash"
import dynamic from "next/dynamic"
import Link from "next/link"
import React, { useEffect } from "react"
import { FaMapMarkerAlt } from "react-icons/fa"
import { useDispatch, useSelector } from "react-redux"

const Nodata = dynamic(() => import("@/components/Lottie/no-data"), {
  ssr: false,
})
const Loader = dynamic(() => import("@/components/Lottie/page-link-loader"), {
  ssr: false,
})

export default function NigerianStates() {
  const dispatch = useDispatch()
  const { states: data, loading } = useSelector((state) => state.auth)
  const [search, setSearch] = React.useState("")
  const filteredRows = data?.filter((row) =>
    row.stateName?.toLowerCase().includes(search.toLowerCase())
  )

  useEffect(() => {
    dispatch(getPublicDashboardStates())
  }, [dispatch])

  const handleChange = ({ target: { value } }) => {
    setSearch(value)
    setPage(0)
  }

  const handleKeyUp = ({ keyCode }) => {
    if (keyCode === 27) handleClearSearch()
  }

  const handleClearSearch = () => {
    setSearch("")
  }
  return (
    <StyledTableCard className="w-full min-h-screen justify-start md:px-4">
      <div className="max-w-screen-xl mx-auto text-center pt-6 flex flex-col gap-2">
        <FormTitle>Explore States Analytics</FormTitle>
        <p className="text-text-color font-base font-gilroy">
          Click on a state to view its public dashboards and analytics
        </p>
      </div>
      <div className="w-full flex justify-end items-end">
        <div className="w-full md:w-[320px]">
          <CustomSearch
            value={search}
            onChange={handleChange}
            onKeyUp={handleKeyUp}
            handleClearSearch={handleClearSearch}
            name="search"
            label=""
            placeholder="Search"
          />
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : isEmpty(filteredRows) ? (
        <Nodata message="No data available" />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredRows?.map((state) => (
            <Link
              key={state.state}
              href={`/dashboards/${state.state
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
              className="bg-white border border-gray-200 rounded-md p-6 shadow-[0px_6px_15px_-2px_rgba(16,24,40,0.05)] transition-all duration-200 flex flex-col items-center text-center"
            >
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <FaMapMarkerAlt className="text-primary text-xl" />
              </div>
              <h3 className="text-lg font-roboto font-bold text-text-color -tracking-[2%]">
                {state.stateName}
              </h3>
              <p className="text-sm text-text-color/60 mt-1">{state.code}</p>
            </Link>
          ))}
        </div>
      )}
    </StyledTableCard>
  )
}
